
import { Resource } from "src/app/core/jsonapi/resource";
import { maxLength, prop, propObject, required } from "@rxweb/reactive-form-validators";
import { TransactionType } from "./transaction-type";
import { TransactionState } from "./transaction-state";
import { Case } from "../../cases/_types/case";
import { ThirdParty } from "./third-party";
import { TransactionSerie } from "../../transactions-series/_types/transaction-serie";
import { CaseService } from "../../cases/_types/case-service";
import { TransactionLine } from "./transaction-line";
import { Business } from "../../business/_types/business";
import { CaseNotificationNumber } from "../../cases/_types/case-notification-number";
import { PaymentMethod } from "../../common/_types/payment-method";
import { User } from "../../users/_types/user";
import { max } from "moment";

export class Transaction extends Resource {
    public override type = 'transactions';    

    @prop()    
    public active: boolean = true;   

    @prop()
    @required()
    public source: number = 1;    

    @prop()
    public thirdPartyType!: string ;    

    @prop()
    public caseId!: string ;    

    @propObject(Case)
    public case!: Case;
    
    @prop()
    public caseServiceId!: string ;    

    @propObject(Case)
    public caseService!: CaseService;
    
    @prop()
    public caseNotificationNumberId!: string ;    

    @propObject(CaseNotificationNumber)
    public caseNotificationNumber!: CaseNotificationNumber;

    @prop()
    public paymentMethodId!: string;    

    @propObject(PaymentMethod)
    public paymentMethod!: PaymentMethod;
    
    @prop()
    @required()
    public transactionTypeId!: string ;    

    @propObject(TransactionType)
    public transactionType!: TransactionType;
    
    @prop()
    @required()
    public transactionStateId!: string ;    

    @propObject(TransactionState)
    public transactionState!: TransactionState;

    @prop()    
    public transactionSerieId!: string ;    

    @propObject(TransactionSerie)
    public transactionSerie!: TransactionSerie;

    @prop()
    @maxLength({value: 45}) //netsuite no admite mas de 45 caracteres en el campo de codigo
    public code!: string;

    @prop()
    public relatedInvoiceCode?: string;

    @prop()
    @required()
    public date!: Date; 

    @prop()
    public paymentDuedate?: Date;

    @prop()
    public thirdPartyId!: string ;    

    @propObject(ThirdParty)
    public thirdParty!: ThirdParty;

    @prop()    
    public subtotal: number = 0;

    @prop()
    public discountAmount: number = 0;

    @prop()    
    public taxAmount: number = 0;
    
    @prop()    
    public total : number = 0;        
    
    @prop()
    public groupByCapability: boolean = false;

    @prop()
    public fileId!: string;

    
    @prop()
    @maxLength({value: 2000})
    public description!: string ;

    @prop()
    public estimatedDateReceipt!: Date;

    @prop()
    public transactionStateNotes!: string ;

    @prop()
    @maxLength({value: 255})
    public internalNotes!: string;

    @prop()
    public paymentConditionsNotes!: string;

    @prop()
    public validityDocNotes!: string;

    @prop()
    public estimatedMaterialDays!: number;

    
    @prop()
    public estimatedWorkHours!: number;

    @prop()
    public relatedTransactionId?: string;

    @prop()
    public relatedTransaction!: Transaction;


    public transactionLines: TransactionLine[] = [];


    @prop()
    public businessId!: string;
    
    @propObject(Business)
    public business!: Business;

    @prop()
    public isReturn: boolean = false;

    @prop()
    public workRetention: number = 0;

    @prop()
    public workRetentionDate!: Date;

    @prop()
    public workRetentionInvoiced: boolean = false;

    @prop()
    public netSuiteId?: string;

    @prop()
    public netSuiteError?: string;

    @prop()    
    public advancedAmmount : number = 0;        

    @prop()    
    public companyPayedAmmount : number = 0;    

    @prop()    
    public payedAmmount?: number;

    @prop()
    public payedDate?:Date;

    @propObject()
    public createdByUser?: User;
    
    @prop()
    public forProfitability: boolean = true;
    
    @prop()
    public externalId?: string;

    @prop()
    public originalProcessorId?: string;
    @propObject()
    public originalProcessor?: User;

    @prop()
    public isAdvancePayment: boolean = false;

}